import gql from "graphql-tag";

export const OC_GET_POLLING = gql`
  query getPolling {
    getPolling
  }
`;
